
export const environment = {
  production: true,
  docsBaseUrl:
    'https://docs.verosoftdesign.com/docs/the-asset-guardian-technician-portal',
  tagPageLink: '/technician-portal-navigation-bar-pages',
  supportLink: '/about-tag-portal',
  forumLink: '/about-tag-portal',
  // Variables that will get replaced by the CI/CD pipeline
  baseWS: 'https://readyfoods-staging-api.theassetguardian.com/api',
  version: 'ReadyFoods Staging - 12.4.1',
  enableTracking: true,
  trackingEnvironment: 'development',
  skipLogin: false,
};
